/* import __COLOCATED_TEMPLATE__ from './date.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();